<div class="container-fluid bg-white vh-100 p-0">
    <div class="d-flex flex-column align-items-center min-vh-0">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="d-flex align-items-center">
                <span><i class="text-muted bi bi-question-circle me-3"></i></span>
                <span class="text-muted text-xs">
                    Please provide your marital information required for the loan
                    application process. This information helps determine the appropriate legal framework for your
                    financial agreement.
                </span>
            </div>

            <div class="form-group mt-4">
                <div class="mb-4 p-3 border rounded shadow-sm">
                    <h5 class="fw-bold mb-3">Marital Information</h5>
                    <div class="mb-3">
                        <label for="marital_status" class="fw-bold text-xs text-start d-block">Marital Status <span
                                class="text-danger">*</span></label>
                        <!-- Marital Status -->
                        <select v-model="client_marital_status" class="form-select rounded-small text-xs" id="marital_status"
                            required @change="handle_marital_status_change">
                            <option value="" selected disabled hidden>Select Marital Status</option>
                            <option v-for="option in marital_status_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_marital_status" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_marital_status }}
                        </small>
                    </div>

                    <div class="mb-3" v-if="client_marital_status === 'MARRIED'">
                        <label for="marriage_type" class="fw-bold text-xs text-start d-block">Marriage Type <span
                                class="text-danger">*</span></label>
                        <!-- Marriage Type -->
                        <select v-model="client_marriage_type" class="form-select rounded-small text-xs" id="marriage_type"
                            required @change="handle_marriage_type_change">
                            <option value="" selected disabled hidden>Select Marriage Type</option>
                            <option v-for="option in marriage_type_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_marriage_type" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_marriage_type }}
                        </small>
                    </div>

                    <div class="mb-3" v-if="client_marital_status === 'MARRIED'">
                        <label for="marriage_date" class="fw-bold text-xs text-start d-block">Marriage Date <span
                                class="text-danger">*</span></label>
                        <input v-model="client_marriage_date" type="date" class="form-control rounded-small shadow-sm w-100"
                            id="marriage_date" required />
                        <small v-if="error_messages.client_marriage_date" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_marriage_date }}
                        </small>
                    </div>
                </div>

                <div class="mb-2 p-3 border rounded shadow-sm" v-if="client_marital_status === 'MARRIED'">
                    <h5 class="fw-bold mb-3">Spouse Information</h5>
                    <div class="mb-3">
                        <label for="spouse_first_name" class="fw-bold text-xs text-start d-block">First Name <span
                                class="text-danger">*</span></label>
                        <input v-model="spouse_first_name" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="spouse_first_name" placeholder="Enter spouse's first name" maxlength="50" required />
                        <small v-if="error_messages.spouse_first_name" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.spouse_first_name }}
                        </small>
                    </div>

                    <div class="mb-3">
                        <label for="spouse_last_name" class="fw-bold text-xs text-start d-block">Last Name <span
                                class="text-danger">*</span></label>
                        <input v-model="spouse_last_name" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="spouse_last_name" placeholder="Enter spouse's last name" maxlength="50" required />
                        <small v-if="error_messages.spouse_last_name" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.spouse_last_name }}
                        </small>
                    </div>

                    <div class="mb-3">
                        <label for="spouse_preferred_name" class="fw-bold text-xs text-start d-block">Preferred
                            Name</label>
                        <input v-model="spouse_preferred_name" type="text"
                            class="form-control rounded-small shadow-sm w-100" id="spouse_preferred_name"
                            placeholder="Enter spouse's preferred name" maxlength="50" />
                        <small v-if="error_messages.spouse_preferred_name" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.spouse_preferred_name }}
                        </small>
                    </div>

                    <div class="mb-3">
                        <label for="spouse_id_type" class="fw-bold text-xs text-start d-block">ID Type <span
                                class="text-danger">*</span></label>
                        <!-- Spouse ID Type -->
                        <select v-model="spouse_id_type" class="form-select rounded-small text-xs" id="spouse_id_type"
                            required>
                            <option value="" selected disabled hidden>Select ID Type</option>
                            <option v-for="option in spouse_id_type_options" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.spouse_id_type" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.spouse_id_type }}
                        </small>
                    </div>

                    <div class="mb-3">
                        <label for="spouse_id_number" class="fw-bold text-xs text-start d-block">ID/Passport Number
                            <span class="text-danger">*</span></label>
                        <input v-model="spouse_id_number" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="spouse_id_number" placeholder="Enter spouse's ID or passport number" required />
                        <small v-if="error_messages.spouse_id_number" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.spouse_id_number }}
                        </small>
                    </div>

                    <div class="mb-3"
                        v-if="['IN COMMUNITY OF PROPERTY', 'TRIBAL LAW', 'FOREIGN LAW'].includes(client_marriage_type)">
                        <label class="fw-bold text-xs mb-2">Do you confirm that your spouse consented in writing to you
                            taking up this loan? <span class="text-danger">*</span></label>
                        <div class="d-flex">
                            <div class="form-check me-3">
                                <input v-model="spouse_consent" type="radio" class="form-check-input"
                                    id="spouse_consent_yes" name="spouse_consent" value="YES" required />
                                <label class="form-check-label text-xs" for="spouse_consent_yes">Yes</label>
                            </div>
                            <div class="form-check">
                                <input v-model="spouse_consent" type="radio" class="form-check-input"
                                    id="spouse_consent_no" name="spouse_consent" value="NO" required />
                                <label class="form-check-label text-xs" for="spouse_consent_no">No</label>
                            </div>
                        </div>
                        <small v-if="error_messages.spouse_consent" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.spouse_consent }}
                        </small>
                    </div>
                </div>

                <div class="mb-3 border p-3 rounded shadow-sm" v-if="client_marital_status && client_marital_status !== 'MARRIED'">
                    <div class="d-flex align-items-center">
                        <span><i class="text-muted bi bi-info-circle me-2"></i></span>
                        <span class="text-muted text-xs">Spouse information is not required for your selected marital
                            status.</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center mb-3 mt-4">
            <button type="button" @click="$emit('previous')" class="btn btn-bg-secondary text-xs fw-bold rounded-small shadow-sm me-1">
                Previous
            </button>
            <button class="btn btn-sm bg-green text-dark rounded-small fw-bold secondary-text-dark shadow-sm"
                @click="submit_marital_info">
                Continue
            </button>
        </div>
    </div>
</div>